import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles({
  tooltipIcon: {
    fontSize: 14,
    marginLeft: 3,
    cursor: 'pointer',
  },
  tooltip: {
    marginLeft: 5,
    marginBottom: 5,
    fontSize: 12,
    fontWeight: 400,
    padding: 15,
    backgroundColor: '#FEFFDE',
    color: 'black',
    border: '1px solid black',
    '& p': {
      marginTop: 10,
    },
  },
  centeredDiv: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonAsLink: {
    color: 'blue',
    cursor: 'pointer',
    textDecoration: 'underline',
    backgroundColor: 'transparent',
    border: 'none',
  },
});
